import React, { Component } from 'react';


export default class WarnComp extends Component {


    constructor(props) {
        super(props);
        
    }
    
    render() {        
       
        return (
            <div className="terms" style={{ display:"flex", justifyContent: 'center' }}>
                <table  style={{ zIndex: '101', backgoundColor: "transparent" }} >
                   
                    <tr style={{ height: '1px' }}>
                       
                        <td  style={{ borderWidth: '0px', borderStyle: 'solid', borderRadius: "5px", width: '300px', height: '275px', borderColor: "grey", backgoundColor: "transparent", padding: "5px 10px 0px 0px" }}>
                            <table className='wh100' >
                                <tr>
                                    <td id='touText' style={{ verticalAlign: 'top', borderColor: "grey", borderWidth: "0px", paddingLeft: '13px' }}>
                                        <span id='lblErrMsg' dangerouslySetInnerHTML={{ __html: this.props.ErrMsg }}></span>
                                       
                                     
                                       
                                    </td>
                                </tr>
                                <tr style={{ height: '1px' }}>
                                    <td style={{ textAlign: 'left', padding: "8px 4px 0px 10px" }}>
                                        <table className='w100'>
                                            <tr>
                                                <td>
                                                    
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                  
                                                        <input id='btnHideWarn' type='button' tabIndex="10" value="Continue" className={"form1-bu"}
                                                        onClick={(e) => {
                                                            this.props.onHideClick();

                                                        } } />
                                                </td>
                                            </tr>
                                        </table>
                                       
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                   
                </table>
            </div>   );

    }
    onTOUAcceptedBtnClick(e) {
        this.props.onHideClick();
    }
}
 